export const REFS = {
  SIZES: {
    S: 's',
    M: 'm'
  }
}
